define('labs/labs',['require','exports','module','durandal/app','knockout','plugins/router','api-access','api-access','api-access','lodash','brightcove','i18next','api-access','cookie-handler','web-urls'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    var gotomeet = require('api-access').gotomeet;
    var _ = require('lodash');
    var brightcove = require('brightcove');
    var i18n = require('i18next');
    var loggingApi = require('api-access').logging;
    var cookieHandler = require('cookie-handler');
    var webUrls = require('web-urls');

    var videoPlayer;
    var labs;
    var page;

    page = {
        getLabidForExperience: function (experience) {
            var labId;
            $.each(labs, function (i, v) {
                if (experience === v.experience) {
                    labId = v.labId;
                }
            });
            return labId;
        },

        videoLoaded: function (experienceID) {
            videoPlayer = brightcove.api.getExperience(experienceID)
                    .getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
        },

        videoReady: function () {
            videoPlayer.addEventListener(brightcove.api.events.MediaEvent.BEGIN, this.videoStartingCallback);
        },

        videoStartingCallback: function (evt) {
            if (evt.type === brightcove.api.events.MediaEvent.BEGIN) {
                var data = {
                    product: 'gotomeeting',
                    labsId: this.getLabidForExperience(evt.target.experience.id),
                    entries: [{action: 'Video Link Clicked'}]
                };

                // create logging entry
                return loggingApi.create(data);
            }
            return undefined;
        }
    };

    function Labs() {
        var self = this;

        self.labsFeatures = ko.observableArray();
        self.meetings = ko.observableArray();
        self.inSessionFlag = ko.observable(false);
        self.existingFeatures = ko.observableArray();
        self.existingLabMeetings = ko.observableArray();
        self.labCookie = ko.observable();
        self.organizerDataReceived = ko.observable(false);
        self.termsAndConditionsFlag = ko.observable(true);
        self.showComingSoon = ko.observable(false);
        self.roomsProvisioned = ko.observable();
        self.roomsEnabled = ko.observable();
        self.roomsAlreadySet = ko.observable();
        self.labsTab = ko.observable();
        self.hasG2mmProfile = ko.observable();
        self.showLabs = ko.observable();

        self.showBeta = ko.computed(function () {
            return self.hasG2mmProfile() && self.roomsProvisioned();
        });

        ko.computed(function () {
            if (window.location.hash) {
                if (window.location.hash.indexOf('#labs') !== -1) {
                    self.labsTab(true);
                } else {
                    // #beta
                    self.labsTab(false);
                }
            }
        });

        self.existingFeatures = ko.computed(function () {
            var features = i18n.t('labs.existing.features');
            return features.split('\n');
        });

        self.onTabClick = function (isLabsTab) {
            self.labsTab(isLabsTab);
            window.location.hash = isLabsTab ? '#labs' : '#beta';
        };

        self.updateRoomsFlag = function (flag) {
            return userApi.updateSettings({
                roomsEnabled: flag
            }).then(function () {
                self.roomsEnabled(flag);
                self.roomsAlreadySet(false);
                // Update SSO enabled flag in GoToMeetMe profile as well.
                return gotomeet.getByUserKey().then(function (profile) {
                    profile.isSsoEnabled = flag;
                    return gotomeet.updateProfileInfo(profile.profileId, profile);
                });
            });
        };

        self.navigateTo = function (url) {
            window.location.href = url;
        };

        self.leaveBeta = function () {
            var leaveModal = {
                message: 'Thank you so much for trying meeting spaces!<br/><br/>' +
                    'When you leave the beta, meeting spaces will be removed from your meetings.',
                title: 'Leave Beta?',
                options: [
                  {text: 'Leave Beta', value: true},
                  {text: 'Not now', value: false}
                ],
                autoClose: true,
                settings: {
                    buttonClass: 'btn',
                    primaryButtonClass: 'btn-primary',
                    secondaryButtonClass: 'btn-secondary'
                }
            };

            app.showMessage(
                leaveModal.message,
                leaveModal.title,
                leaveModal.options,
                leaveModal.autoClose,
                leaveModal.settings
            )
                .then(function (leave) {
                    if (leave) {
                        self.updateRoomsFlag(false)
                            .then(function () {
                                self.termsAndConditionsFlag(true);
                            });
                    }
                });
        };

        self.disclaimerHandler = function (lab) {
            var cookie = self.labCookie();
            var meetingSettings = lab;
            var message = [
                i18n.t('labs.legal.disclaimer'),
                i18n.t('labs.review'),
                [i18n.t('labs.agree'), i18n.t('action.cancel')]
            ];

            if (cookie === null) {
                app.showMessage.apply(app, message)
                    .then(function (res) {
                        if (res === message[2][0]) {
                            // user agrees, send agree post and start meeting
                            self.disclaimerAccepted(meetingSettings);
                        } else {
                            // user declines
                            self.disclaimerDeclined();
                        }
                    });
            } else {
                self.createLab(meetingSettings);
            }
        };

        self.createLab = function (lab) {
            var meetingSettings = {
                meetingType: 'recurring',
                subject: 'Labs with ' + lab.name,
                passwordRequired: false,
                labId: lab.labId
            };

            return meetingsApi.create(meetingSettings)
                .then(function (data) {
                    var url = '/host/' + data.meetingId;
                    window.location = url;
                });
        };

        self.startLab = function (lab) {
            var url = '/host/';
            _.forEach(self.meetings(), function (meeting) {
                if (meeting.labId === lab.labId) {
                    window.location = url + meeting.meetingId;
                }
            });
        };

        self.disclaimerDeclined = function () {
            // redirect to my meetings
            return router.navigate('/');
        };

        self.disclaimerAccepted = function (meetingSettings) {
            var cookie = self.labCookie();

            if (cookie === null) {
                cookieHandler.set(60, 'labs-legal', 'true');
            }

            // create meeting
            self.createLab(meetingSettings);
        };

        self.compositionComplete = function () {
            brightcove.createExperiences();
        };

        // borrowed from original labs implementation
        self.getLabCookie = function (cookieName) {
            if (document.cookie.length > 0) {
                var cookieStart = document.cookie.indexOf(cookieName + '=');
                var cookieEnd;
                if (cookieStart !== -1) {
                    cookieStart = cookieStart + cookieName.length + 1;
                    cookieEnd = document.cookie.indexOf(';', cookieStart);
                    if (cookieEnd === -1) {
                        cookieEnd = document.cookie.length;
                    }
                    return decodeURIComponent(document.cookie.substring(cookieStart, cookieEnd));
                }
            }
            return null;
        };

        // prevent user from access labs page if
        // they don't have English locale
        self.canActivate = function () {
            return i18n.lng().indexOf('en') > -1;
        };

        self.activate = function () {
            // set cookie
            self.labCookie(cookieHandler.get('labs-legal'));

            userApi.getLabsFeatures()
                .then(function (data) {
                    self.labsFeatures(data);
                    labs = data;

                    meetingsApi.forOrganizerFormatted()
                        .then(function (dataResponse) {
                            _.forEach(dataResponse, function (meeting) {
                                if (meeting.labId) {
                                    self.existingLabMeetings.push(meeting.labId);
                                    self.inSessionFlag(meeting.screenSharing);
                                }
                            });
                            self.meetings(dataResponse);
                            self.organizerDataReceived(true);
                        });
                })
                .fail(function () {
                    location.reload();
                });

            userApi.settings()
                .then(function (settings) {
                    self.showLabs(settings.sightboardProvisioned);
                    self.roomsProvisioned(settings.roomsProvisioned);
                    self.roomsEnabled(settings.roomsEnabled);
                    self.roomsAlreadySet(settings.roomsEnabled);

                    // make sure we set the tab to labs if we are not
                    // showing the beta page
                    if (!self.roomsProvisioned() && !self.showLabs()) {
                        window.location.href = webUrls.get('baseUrl');
                    }
                });

            // Show Beta tab only if the user has a G2MM profile.
            gotomeet.getByUserKey().done(function () {
                self.hasG2mmProfile(true);
            }).fail(function () {
                self.hasG2mmProfile(false);

                // If linked to Beta page and the user doesn't have G2MM profile
                //    -- redirect them to Meeting Dashboard home.
                if (!self.labsTab()) {
                    self.navigateTo(webUrls.get('baseUrl'));
                }
            });
        };
    }

    // expose global variable for tracking :(
    window.page = page;

    module.exports = Labs;
});

